import {
  VAvatarConfig as VAvatar,
  VInputConfig as VInput,
  VTextFieldConfig as VTextField,
  VCheckboxConfig as VCheckbox,
} from './components';

export const sysdyneThemeConfig = {
  VAvatar,
  VCheckbox,
  VCheckboxBtn: VCheckbox,
  VInput,
  VTextField,
};
